import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from './Session';

@Injectable({
  providedIn: 'root'
})
export class TestAuth {
  private readonly STORAGE_KEY = 'testAuthToken';
  private readonly VALID_USERNAME = 'testuser';
  private readonly VALID_PASSWORD = 'testpass123';

  constructor(private router: Router, private session: Session) {}

  login(username: string, password: string): boolean {
    if (username === this.VALID_USERNAME && password === this.VALID_PASSWORD) {
      try {
        localStorage.setItem(this.STORAGE_KEY, 'true');
        return true;
      } catch (e) {
        console.error('Failed to save auth token:', e);
        return false;
      }
    }
    return false;
  }

  logout() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (e) {
      console.error('Failed to remove auth token:', e);
    }
  }

  isAuthenticated(): boolean {
    if (!this.hasCrmSession()) {
      return false;
    }
    try {
      return localStorage.getItem(this.STORAGE_KEY) === 'true';
    } catch (e) {
      console.error('Failed to read auth token:', e);
      return false;
    }
  }

  hasCrmSession(): boolean {
    const token = this.session.getToken();
    return !!token && token.length > 0;
  }

  redirectToLogin() {
    this.router.navigate(['/test/login']);
  }
}